export default __webpack_public_path__ + "static/media/1176_IMG6129.2048542c.jpg";